import { render, staticRenderFns } from "./CurrentSectionStudent.vue?vue&type=template&id=376df557&scoped=true"
import script from "./CurrentSectionStudent.vue?vue&type=script&lang=js"
export * from "./CurrentSectionStudent.vue?vue&type=script&lang=js"
import style0 from "./CurrentSectionStudent.vue?vue&type=style&index=0&id=376df557&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376df557",
  null
  
)

export default component.exports